import TaskCard from './TaskCard.vue'
import type { TaskType } from '@/components/TaskSlider'

export interface Props {
  item: TaskType
  routeName?: string
}

export default TaskCard